import _defineProperty from "C:\\wamp64\\www\\aiscan\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _classCallCheck from "C:\\wamp64\\www\\aiscan\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\wamp64\\www\\aiscan\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import { ReduxStorageUtils } from "./ReduxStorageUtils";
var ActionUUID = 0;
export var ActionBuilder =
/*#__PURE__*/
function () {
  function ActionBuilder() {
    _classCallCheck(this, ActionBuilder);
  }

  _createClass(ActionBuilder, null, [{
    key: "generateNewActionUUID",

    /**
     * Generates an Universal Unique Identifier that is going to be used as type for an action
     *
     * Redux Equivalent Example:
     *
     * {
     *     type: "ACTION_0_updateNameText",                              // <- This
     *     payload: ...
     * }
     *
     * @param key
     * @return {string}
     */
    value: function generateNewActionUUID(key) {
      return "ACTION_".concat(ActionUUID++, "_").concat(key);
    }
    /**
     * Private helper for the #injectAutoMapToProps() function
     *
     * @param dispatch
     * @param actionsObject
     * @param mapObject
     */

  }, {
    key: "injectMapDispatchMapValues",
    value: function injectMapDispatchMapValues(dispatch, actionsObject, mapObject) {
      Object.keys(actionsObject).forEach(function (key) {
        mapObject[key] = function () {
          return dispatch(actionsObject[key].apply(actionsObject, arguments));
        };
      });
    }
  }, {
    key: "injectMapValuesFromReduxActions",

    /**
     * Generates a map of function/object merge ready to be used with ReducerBuilder
     *
     * Conversion Example:
     *
     * {
     *     updateNameText: (name: string) => ({name})
     * }
     *
     * Becomes:
     *
     * {
     *     updateNameText: {
     *         (name: string) => ({
     *             payload: name,
     *             type: "ACTION_0_updateNameText"                                  // <- See #generateNewActionUUID()
     *         }),
     *         type: "ACTION_0_updateNameText",                                     // <- Used by ReducerBuilder for indexing purposes
     *         asConnectedAction: (name: string) => ReduxStorageUtils.dispatch({
     *             payload: name,
     *             type: "ACTION_0_updateNameText"
     *         })
     *     }
     * }
     *
     * @param finalObj
     * @param actionsObject
     */
    value: function injectMapValuesFromReduxActions(finalObj, actionsObject) {
      Object.keys(actionsObject).forEach(function (key) {
        var type = ActionBuilder.generateNewActionUUID(key);
        var action;

        action = function action() {
          return {
            payload: actionsObject[key].apply(actionsObject, arguments),
            type: type
          };
        };

        action.type = type;

        action.asConnectedAction = function () {
          return ReduxStorageUtils.dispatch(action.apply(void 0, arguments));
        };

        finalObj[key] = action;
      });
    }
  }, {
    key: "injectAutoMapToProps",

    /**
     * Creates a "autoMapToProps" property in the final object. This property once called will create a dispatch function
     * that will return a object with every key and their dispatch value.
     *
     * Example:
     *
     * {
     *     updateNameText: (name: string) => ({name})
     * }
     *
     * Becomes:
     *
     * (dispatch) => {
     *     updateNameText: (name: string) => ({
     *         type: "ACTION_0_updateNameText",                                  // <- See #generateNewActionUUID()
     *         payload: name
     *     })
     * }
     *
     *
     * @param actionObject
     */
    value: function injectAutoMapToProps(actionObject) {
      actionObject["autoMapToProps"] = function (propGroupName) {
        return function (dispatch) {
          var result = {};
          ActionBuilder.injectMapDispatchMapValues(dispatch, actionObject, result);
          return propGroupName ? _defineProperty({}, propGroupName, result) : result;
        };
      };
    }
  }, {
    key: "build",

    /**
     *
     * @param actionsObj
     * @return object
     */
    value: function build(actionsObj) {
      var result = {};
      ActionBuilder.injectMapValuesFromReduxActions(result, actionsObj);
      ActionBuilder.injectAutoMapToProps(result);
      return result;
    }
  }, {
    key: "combineActionsAutoMaps",
    value: function combineActionsAutoMaps() {
      for (var _len = arguments.length, actions = new Array(_len), _key = 0; _key < _len; _key++) {
        actions[_key] = arguments[_key];
      }

      return function (dispatch) {
        return actions.reduce(function (finalObj, currentAction) {
          Object.assign(finalObj, currentAction(dispatch));
          return finalObj;
        }, {});
      };
    }
  }]);

  return ActionBuilder;
}();